import React from 'react';
import { Plane } from 'lucide-react';
import styles from './Loading.module.css';

interface LoadingProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  fullScreen?: boolean;
}

const Loading: React.FC<LoadingProps> = ({ 
  size = 'medium', 
  text = 'Carregando...', 
  fullScreen = false 
}) => {
  const containerClass = fullScreen 
    ? `${styles.container} ${styles.fullScreen}` 
    : styles.container;

  return (
    <div className={containerClass}>
      <div className={`${styles.spinner} ${styles[size]}`}>
        <div className={styles.trail}></div>
        <Plane className={styles.plane} />
      </div>
      {text && <p className={styles.text}>{text}</p>}
    </div>
  );
};

export default Loading;
